var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#FF4747",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 32.875C33 33.1734 32.8752 33.4595 32.6532 33.6705C32.4311 33.8815 32.1299 34 31.8158 34H19.1842C18.8701 34 18.5689 33.8815 18.3468 33.6705C18.1248 33.4595 18 33.1734 18 32.875C18 32.5767 18.1248 32.2905 18.3468 32.0796C18.5689 31.8686 18.8701 31.7501 19.1842 31.7501H19.5789C20.2071 31.7501 20.8095 31.513 21.2537 31.0911C21.6978 30.6692 21.9474 30.0969 21.9474 29.5002V26.5003H19.1842C18.8701 26.5003 18.5689 26.3818 18.3468 26.1708C18.1248 25.9598 18 25.6737 18 25.3753C18 25.077 18.1248 24.7908 18.3468 24.5798C18.5689 24.3689 18.8701 24.2504 19.1842 24.2504H21.9474V21.2505C21.9472 20.2549 22.2451 19.2798 22.8063 18.4389C23.3674 17.5981 24.1687 16.9261 25.1166 16.5015C26.0645 16.0768 27.12 15.917 28.1599 16.0406C29.1998 16.1643 30.1813 16.5662 30.9898 17.1997C31.232 17.3896 31.3849 17.6632 31.4148 17.9602C31.4447 18.2573 31.3491 18.5534 31.1492 18.7835C30.9492 19.0136 30.6612 19.1589 30.3486 19.1872C30.0359 19.2156 29.7241 19.1249 29.4819 18.9349C28.9178 18.49 28.2069 18.2478 27.4737 18.2506C26.6362 18.2506 25.8329 18.5666 25.2407 19.1292C24.6485 19.6918 24.3158 20.4548 24.3158 21.2505V24.2504H27.0789C27.393 24.2504 27.6942 24.3689 27.9163 24.5798C28.1384 24.7908 28.2632 25.077 28.2632 25.3753C28.2632 25.6737 28.1384 25.9598 27.9163 26.1708C27.6942 26.3818 27.393 26.5003 27.0789 26.5003H24.3158V29.5002C24.3167 30.2903 24.0975 31.0666 23.6803 31.7501H31.8158C32.1299 31.7501 32.4311 31.8686 32.6532 32.0796C32.8752 32.2905 33 32.5767 33 32.875Z",
    fill: "#F51932"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPound);
export default __webpack_public_path__ + "static/media/pound.423664f865c7c5ca15a00b62cb80118b.svg";
export { ForwardRef as ReactComponent };